import styled from "styled-components";
import { styled as styledMui } from "@material-ui/core/styles"
import { Accordion, AccordionSummary } from "@material-ui/core"
import { theme } from '../../theme'

export const StyledTopWrapper = styled.div`
    background-color: ${theme.colors.mainBlue};
`
export const StyledContainer = styled.div`
    margin: 0 auto;
    padding: 1rem 1rem;
    max-width: 888px;
`

export const StyledNextPageDivContainer = styled.div`
    margin: 0 auto;
    padding: 1rem 1rem;
    max-width: 888px;
    display: flex;
    align-items: center;
    gap: 4rem;

    @media(max-width: 376px) {
        flex-direction: column;
        gap: 2rem;
    }

    .subject-instructor-info-div {
        display: flex;
        align-items: center;
        gap: 7px;

        .subject-instructor-info-name {
            font-weight: 700;
            font-size: 1.2rem;
        }

        .subject-instructor-info-position {
            font-size: 1rem;
            color: #979797;
        }
    }

    .class-icon-div {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 1.2rem;
        /* margin-left: 4rem; */

        .check-icon-container {
            width: 2rem;
            height: 2rem;
            margin-right: 5px;
            color: #979797;
            svg {
                width: 100%;
                height: 100%;
            }
        }
    }

    .next-page-btn-div {
       margin-left: auto;
    }
`

export const StyledMainContentWrapper = styled.div`
background-color: ${theme.colors.grey03};
height: ${({ fullHeight }) => (fullHeight && '100%')};
`
export const StyledNextPageDiv = styled.div`
background-color: ${theme.colors.mainWhite};

`
export const StyledContent = styled.div`
color: ${theme.colors.mainWhite} !important;
    .top {        
        .subject-title {
            font-weight: 700;
            font-size: 5.1rem;
            
            @media only screen and (max-width: 326px) {
                font-size: 4.1rem;
            }
        }
    }

    .bottom {
        font-size: 1.2rem;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
    }

    .download-assignment-btns {
        display: flex;
        align-items: center;
        gap: 1.5rem;

        

        @media(max-width: 500px) {
            flex-direction: column;
        }
    }
`
export const StyledContentGrid = styled.div`
 display: grid;
 /* grid-template-columns: 1fr auto; */
 grid-template-columns: repeat(auto-fit, minmax(34.4rem, 1fr));
 column-gap: 6.4rem;
 row-gap: 2rem;
`
export const AboutInstructorSection = styled.div`
    background-color: #FFFFFF;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
`
export const AboutInstructorContentWrapper = styled.div`
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    gap: 21.1rem;
    padding: 4.4rem 0;
`
export const AboutInstructorContent = styled.div`
   .heading-text {
        font-weight: bold;
        font-size: 1.6rem;
        color: #000000;
   }
   .main-text {
    font-size: 12px;
    color: #979797;
   }
`
export const AboutInstructorExtraInfo = styled.div`
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

   .instructor-extra-info-name {
    font-weight: bold;
    font-size: 1.8rem;
    color: #3B3B42;
   }
   .instructor-extra-info-position {
    font-size: 1rem;
    color: #979797;
   }
`

export const StyledAccordion = styledMui(Accordion)(({ theme }) => ({
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    marginBottom: '2.1rem',
    // ".css-1xx5que-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
    //     minHeight: 0,
    // },
    "&:before": {
        display: 'none',
    },
}));
export const StyledAccordionSummary = styledMui(AccordionSummary)(({ theme }) => ({
    minHeight: 0,

    "&.Mui-expanded": {
        minHeight: 0,
    },
    ".css-o4b71y-MuiAccordionSummary-content": {
        alignItems: 'center',
        gap: '1rem',
        margin: 0
    },
    ".styled-summary-title": {
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        fontSize: '1.4rem',
        textTransform: 'uppercase',
    },
    ".horizontal-line": {
        height: '1px',
        backgroundColor: '#DFE1E4',
        width: '100%'
    }
}));